module.exports = __webpack_public_path__ + "static/media/page-before.5f946f2e.svg";